import { z } from 'zod/v4';
export var CaseHistoryFocusKind;
(function (CaseHistoryFocusKind) {
    CaseHistoryFocusKind["Proposal"] = "proposal";
    CaseHistoryFocusKind["Interaction"] = "interaction";
})(CaseHistoryFocusKind || (CaseHistoryFocusKind = {}));
// `kind:uuid`, so a URL can point at exactly one entry of a known kind.
export const caseHistoryFocusSchema = z.templateLiteral([
    z.enum(CaseHistoryFocusKind),
    ':',
    z.uuid(),
]);
export const caseHistoryFocus = (kind, id) => `${kind}:${id}`;
export const caseHistoryLink = (caseId, kind, id) => `/cases/${caseId}?focus=${caseHistoryFocus(kind, id)}`;
//# sourceMappingURL=focus.js.map